import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";

import Context from "context/context";
import vraRoster from "apis/panel/vraRoster/vraRoster";
import getAllVraShiftAPIS from "apis/panel/vraShifts/vraShifts.js";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Autocomplete from '@mui/material/Autocomplete';
import moment from "../../../../../node_modules/moment/moment";

const EditVraRoster = ({ id, onClose }) => {
  const { dispatch } = useContext(Context);

  const [vrasrfname, setvrasrfname] = useState("");
  const [remarks, setRemarks] = useState("");
  const [vrarpuserid, setvrarpuserid] = useState("");
  const [primaryShift, setPrimaryShift] = useState("");
  const [currentProject, setCurrentProject] = useState("");
   const [currentProjectStartDate, setCurrentProjectStartDate] = useState("");
  const [deployedDate, setDeployedDate] = useState(null);
  const [role, setrole] = useState("");
  const [employmentType, setemploymentType] = useState("");
  const [status, setStatus] = useState("");
  const [deploymentStatus, setDeploymentStatus] = useState("");
  // const [commitmentDate, setCommitmentDate] = useState(null);
  const [reportingManagerVraId, setReportingManagerVraId] = useState("");
  const [vraEmployees , setVraEmployees]= useState([])

  const { getVraRosterFindOne, updateVraRosterAPI } = vraRoster();
  const {getAllVraRosterAPI}= getAllVraShiftAPIS()

  const maxDate = new Date();

  useEffect(() => {
    handleGetEditDataObj();
  }, []);

  const handleGetEditDataObj = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let values;
      values = {
        vraRosterId: id,
      };
      const res = await getVraRosterFindOne(values);
      if (res?.data) {
        setvrasrfname(res?.data?.vraRoster?.vraUserName);
        setRemarks(res?.data?.vraRoster?.remarks)
        setvrarpuserid(res?.data?.vraRoster?.vraName);
        setStatus(res?.data?.vraRoster?.status);
        setPrimaryShift(res?.data?.vraRoster?.primaryShift);
        setCurrentProject(res?.data?.vraRoster?.currentProject)
         setCurrentProjectStartDate(res?.data?.vraRoster?.currentProjectStart)
        setDeployedDate(res?.data?.vraRoster?.deployedDate);
        setemploymentType(res?.data?.vraRoster?.engagementType);
        setrole(res?.data?.vraRoster?.role);
        // setCommitmentDate(res?.data?.vraRoster?.commitmentDate);
        setReportingManagerVraId(res?.data?.vraRoster?.reportingManagerVraId)
        setDeploymentStatus(res?.data?.vraRoster?.deploymentStatus)
      }
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (error) {
      console.log({ error });
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleGetAllVraEmployees = async () => {
    try {
        let res = await getAllVraRosterAPI();
        setVraEmployees(res?.data?.vraMaster || []);
        }
    catch (err) {}
  };

  useEffect(()=>{
    handleGetAllVraEmployees()
  },[])

  const [errorFields, setErrorFields] = useState({
    vrasrfname: false,
    vrarpuserid: false,
    deployedDate: false,
    currentProject:false,
    currentProjectStartDate:false,
    
    role: false,
    employmentType: false,
    status: false,
   deploymentStatus:false,
    primaryShift:false,
    
  });

  const handleSaveRadRosterEdit = async (e) => {
    e.preventDefault();

    const errors = {};

    if (!vrasrfname) errors.vrasrfname = true;
    if (!vrarpuserid) errors.vrarpuserid = true;
    if (!primaryShift) errors.primaryShift = true;
    if(!currentProject) errors.currentProject=true;
    if(!currentProjectStartDate) errors.currentProjectStartDate=true;
    if (!role) errors.role = true;
    if (!employmentType) errors.employmentType = true;
    if (!status) errors.status = true;
    if (!deploymentStatus) errors.deploymentStatus = true;
    // if(!deployedDate) errors.deployedDate = true;
    setErrorFields(errors);

    if (Object.keys(errors).length === 0) {
      let values = {
        vraRosterId: id,
        primaryShift: primaryShift,
        currentProject:currentProject,
       
        status: status,
        srfName: vrasrfname,
        vraFullName: vrarpuserid,
        role: role,
        engagementType: employmentType,
        reportingManagerVraId,
        deploymentStatus
      };
      if(remarks){
        values= {
          ...values,
          remarks:remarks
        }
      }
      if(moment(deployedDate).isValid()){
        values = {...values, deployedDate: moment(deployedDate).format("YYYY-MM-DD") }
      }
       if(moment(currentProjectStartDate).isValid()){
        values = {...values, currentProjectStartDate: moment(currentProjectStartDate).format("YYYY-MM-DD") }
      }
      
      dispatch({ type: "SET_LOADING", payload: true });

      const res = await updateVraRosterAPI(values);

      if (res.status === "Ok") {
        onClose();
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.success("Data Saved Successfully", {
          toast: "Data Saved Successfully",
        });
      } else {
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.error("Error: User already exists in the system");
      }
    }
  };

  const handlevrasrfnameChange = (event) => {
    const input = event.target.value;
    setvrasrfname(input);
  };

  const handleRemarkChange = (event) => {
    const input = event.target.value;
    setRemarks(input);
  };

  const handleVraIdChange = (event) => {
    const input = event.target.value;
    setvrarpuserid(input);
  };

  const handleprimary = (event) => {
    const input = event.target.value;
    setPrimaryShift(input);
  };

  const handleCurrentProject = (event) => {
    const input = event.target.value;
    setCurrentProject(input);
  };

  const handleCurrentProjectStartDateChange = (date) => {
   
    setCurrentProjectStartDate(date);
  };

  const handleemploymentTypeChange = (event) => {
    const input = event.target.value;
    setemploymentType(input);
  };

  const handleroleChange = (event) => {
    const input = event.target.value;
    setrole(input);
  };

  

  const handleDeployedDateChange = (date) => {
    setDeployedDate(date);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <Grid container spacing={2} sx={{ pl: 4, pr: 5 }}>
        
        {/* VRA SRF Name */}

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            VRA SRF Name <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="vrasrfname"
            value={vrasrfname}
            onChange={handlevrasrfnameChange}
            placeholder="Enter VRA SRF Name"
            variant="outlined"
            fullWidth
          />
          {errorFields.vrasrfname && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>

        {/* Client Email ID */}

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Client Email ID <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="vrarpuserid"
            value={vrarpuserid}
            onChange={handleVraIdChange}
            placeholder="Enter Client Email ID"
            variant="outlined"
            fullWidth
          />
          {errorFields.vrarpuserid && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>

        {/* Primary Shift */}

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Primary Shift<span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="primary-shift"
              id="primary-shift"
              defaultValue=""
              displayEmpty
              name="primary-shift"
              value={primaryShift}
              onChange={handleprimary}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem disabled value={""}>
                {" "}
                <em>Select an Option</em>
              </MenuItem>
              <MenuItem value={"Morning"}>Morning</MenuItem>
              <MenuItem value={"Evening"}>Evening</MenuItem>
              <MenuItem value={"Night"}>Night</MenuItem>
              <MenuItem value={"Overnight"}>Overnight</MenuItem>
                <MenuItem value={"Not Applicable"}>Not Applicable</MenuItem>
            </Select>
          </FormControl>
          {errorFields.primaryShift && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>

        {/* Role */}

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Role<span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="role"
              id="role"
              defaultValue=""
              displayEmpty
              name="role"
              value={role}
              onChange={handleroleChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem disabled value={""}>
                {" "}
                <em>Select an Option</em>
              </MenuItem>
              <MenuItem value={"Associate POD Manager"}>
                Associate POD Manager
              </MenuItem>
              <MenuItem value={"Delivery Manager"}>Delivery Manager</MenuItem>
              <MenuItem value={"Launch VRA"}>Launch VRA</MenuItem>
              <MenuItem value={"Learning & Development Head"}>
                Learning & Development Head
              </MenuItem>
              <MenuItem value={"Operations Manager"}>
                Operations Manager
              </MenuItem>
              <MenuItem value={"POD Manager"}>POD Manager</MenuItem>
              <MenuItem value={"SME"}>SME</MenuItem>
              <MenuItem value={"Trainer"}>Trainer</MenuItem>
              <MenuItem value={"VRA"}>VRA</MenuItem>
              <MenuItem value={"VRA Onboarding Associate Manager"}>
                VRA Onboarding Associate Manager
              </MenuItem>
              <MenuItem value={"VRA Process Excellence Head"}>
                VRA Process Excellence Head
              </MenuItem>
              <MenuItem value={"ATC"}>
                ATC
              </MenuItem>
              <MenuItem value={"WFC"}>
               WFC
              </MenuItem>
<MenuItem value={"Data Analyst"}>
               Data Analyst
              </MenuItem>
              <MenuItem value={"Training Support"}>
               Training Support
              </MenuItem>
              <MenuItem value={"SME - Launch"}>
               SME - Launch
              </MenuItem>
              <MenuItem value={"Mosaic Scheduler"}>Mosaic Scheduler</MenuItem>
                <MenuItem value={"Not Applicable"}>Not Applicable</MenuItem>
            </Select>
          </FormControl>
          {errorFields.role && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>

{/* Project/Service */}
         <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Employee Roster<span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="currentProject"
              id="currentProject"
              defaultValue=""
              displayEmpty
              name="currentProject"
              value={currentProject}
              onChange={handleCurrentProject}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem disabled value={""}>
                {" "}
                <em>Select an Option</em>
              </MenuItem>
              <MenuItem value={"RP"}>RP</MenuItem>
              <MenuItem value={"AI Enablement"}>AI Enablement</MenuItem>
              <MenuItem value={"eBV"}>eBV</MenuItem>
               <MenuItem value={"Admin"}>Admin</MenuItem>
                <MenuItem value={"HR"}>HR</MenuItem>
                 <MenuItem value={"IT Support"}>IT Support</MenuItem>
                  <MenuItem value={"Compliance"}>Compliance</MenuItem>
                   <MenuItem value={"Technology"}>Technology</MenuItem>
                    <MenuItem value={"Testing"}>Testing</MenuItem>
                     <MenuItem value={"Finance"}>Finance</MenuItem>
                <MenuItem value={"Not Applicable"}>Not Applicable</MenuItem>
            </Select>
          </FormControl>
          {errorFields.currentProject && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>

        {/* Current project start Date */}

          <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Current Project Start Date <span style={{ color: "red" }}>*</span>
          </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="currentProjectStartDate"
              name="currentProjectStartDate"
              value={currentProjectStartDate ? new Date(currentProjectStartDate) : null}
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleCurrentProjectStartDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
          {errorFields.currentProjectStartDate && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>

{/* Employment Type */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Employment Type <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="billing-engagement-type"
              id="billing-engagement-type"
              defaultValue=""
              displayEmpty
              name="billing-engagement-type"
              value={employmentType}
              onChange={handleemploymentTypeChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem disabled value={""}>
                {" "}
                <em>Select an Option</em>
              </MenuItem>
              <MenuItem value={"Resident"}>Resident</MenuItem>
              <MenuItem value={"Intern"}>Intern</MenuItem>
               <MenuItem value={"Contractor"}>Contractor</MenuItem>
                 <MenuItem value={"Not Applicable"}>Not Applicable</MenuItem>
            </Select>
          </FormControl>
          {errorFields.employmentType && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>

{/* Deployed Date */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Deployed Date
          </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="deployedDate"
              name="deployedDate"
              value={deployedDate ? new Date(deployedDate) : null}
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleDeployedDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
          {/* {errorFields.deployedDate && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )} */}
        </Grid>
{/* Reportimg Manager */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
          Reporting Manager (RP ID)
          </Box>
          <Autocomplete
            id="reporting-manager-rp-id"
            options={vraEmployees?.filter(v=>v.vraRosterId !== id)}
            getOptionLabel={(option) => option.vraFullname || ""}
            renderInput={(params) => <TextField {...params} fullWidth />}
            isOptionEqualToValue={(option, value) => option.vraRosterId === value.vraRosterId}
            value={vraEmployees?.filter(v=> v.vraRosterId === reportingManagerVraId)[0] ||{}}
            onChange={(event, newValue) => {
                setReportingManagerVraId(newValue ? newValue.vraRosterId : ""); 
            }}
          />
          {errorFields.reportingManagerVraId && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>
{/* Employment Status */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Employment Status <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="status"
              id="status"
              defaultValue=""
              displayEmpty
              name="status"
              value={status}
              onChange={handleStatusChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem disabled value={""}>
                {" "}
                <em>Select an Option</em>
              </MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
             
              <MenuItem value={"Inactive"}>Inactive</MenuItem>
               <MenuItem value={"Sabbatical"}>Sabbatical</MenuItem>
                <MenuItem value={"Maternity Leave"}>Maternity Leave</MenuItem>
                <MenuItem value={"Long Leave"}>Long Leave</MenuItem>
                 <MenuItem value={"In notice period"}>In notice period</MenuItem>
                  <MenuItem value={"Internal movement"}>Internal movement</MenuItem>
                   <MenuItem value={"Not Applicable"}>Not Applicable</MenuItem>
            </Select>
          </FormControl>
          {errorFields.status && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>
{/* Deployment Status */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
          Deployment Status <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="deployment-status"
              id="deployment-status"
              defaultValue=""
              displayEmpty
              name="deployment-status"
              value={deploymentStatus}
              onChange={(e)=>{
                setDeploymentStatus(e.target.value)
              }}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem disabled value={""}>
                {" "}
                <em>Select an Option</em>
              </MenuItem>
              <MenuItem value={"Training"}>Training</MenuItem>
              <MenuItem value={"Bullpen"}>Bullpen</MenuItem>
              <MenuItem value={"Deployed"}>Deployed</MenuItem>
              <MenuItem value={"Not Applicable"}>Not Applicable</MenuItem>
            </Select>
          </FormControl>
          {errorFields.deploymentStatus && (
            <span
              className="error-msg"
              style={{ display: "flex", paddingTop: "10px" }}
            >
              This is required Field
            </span>
          )}
        </Grid>
{/* Remarks */}
         <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 2 }}>
          <Box className="label">
            Remarks 
          </Box>
         <TextField
    sx={{
      border: "1px solid #B2D4F8",
      "& .MuiOutlinedInput-root": {
        alignItems: "flex-start", // aligns text at the top
      },
    }}
    id="remarks"
    value={remarks}
    onChange={handleRemarkChange}
    placeholder="Enter the remarks"
    variant="outlined"
    fullWidth
    multiline
    minRows={4} 
  />
  
         
        </Grid>

      </Grid>

      <Grid container sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }}>
        <Grid item xs={12} sm={2} md={2} lg={2}>
          <Button className="cancelButton" onClick={onClose}>
            Cancel
          </Button>
        </Grid>

        <Grid item sx={{ mr: 1 }} xs={12} sm={2} md={2} lg={2}>
          <Button className="saveButton" onClick={handleSaveRadRosterEdit}>
            Save
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default EditVraRoster;
